<div class="py-4 px-0 material-view">
  <div class="container">
    @if (materialIsLoading) {
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    } @else {
      @if (materialIsArchived) {
        <app-archived-material [materialId]="materialId.toString()"></app-archived-material>
      } @else {
        @if (expired) {
          <alert type="warning">
            {{ "demo.educationalMaterial.expired" | translate: { date: educationalMaterial.expires | date: "d.M.yyyy" } }}
          </alert>
        }
        <div class="row mb-4">
          <div class="col-lg-6">
            <h1>{{ materialName }}</h1>
          </div>
          <div class="col-lg-6 text-lg-end">
            <div class="material-actions">
              @if (authService.hasUserData()) {
                <button type="button" class="btn btn-link" (click)="openCollectionModal($event)">
                  {{ "demo.educationalMaterial.addToCollection" | translate }}
                </button>
              }
              @if (educationalMaterial.owner) {
                <a class="btn btn-link" [routerLink]="['/muokkaa-oppimateriaalia', materialId, 1]">
                  <i class="fa fa-fw fa-edit text-dark" aria-hidden="true"></i>
                  {{ "demo.educationalMaterial.edit" | translate }}
                </a>
              }
              @if (educationalMaterial.hasDownloadableFiles) {
                <div class="dropdown" dropdown>
                  <button
                    class="btn btn-blue dropdown-toggle"
                    dropdownToggle
                    id="dropdownMenuButton"
                    aria-haspopup="true">
                    {{ "demo.educationalMaterial.download" | translate }}
                  </button>
                  <div *dropdownMenu class="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuButton">
                    <a class="dropdown-item" [href]="downloadUrl" download>
                      {{ "demo.educationalMaterial.downloadAllFiles" | translate }}
                    </a>
                    <strong class="dropdown-header">
                      {{ "demo.educationalMaterial.downloadSingleFile" | translate }}
                    </strong>
                    @for (materialLang of materialLanguages; track materialLang) {
                      @if (materialLanguages.length > 1) {
                        <strong class="dropdown-header">
                          {{ getLanguageValue(materialLang) }}
                        </strong>
                      }
                      @if (materials | materialLanguage: materialLang; as filteredMaterials) {
                        @for (material of filteredMaterials; track material) {
                          @if (!material.downloadUrl.endsWith(nullDownloadUrl)) {
                            <a
                              class="dropdown-item"
                              [href]="material.downloadUrl"
                              download>
                              {{ material.displayName[lang] }}
                            </a>
                          }
                        }
                      }
                    }
                    <!---->
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-3">
            <div class="material-sidebar-left">
              <div class="row">
                <div class="col-auto col-lg-12 text-center text-sm-start">
                  <img
                    [src]="educationalMaterial.thumbnail"
                    class="img-fluid mb-4"
                    [alt]="'demo.educationalMaterial.cover.alt' | translate" />
                </div>
                <div class="col col-lg-12">
                  <ul class="list-unstyled">
                    @for (type of educationalMaterial.learningResourceTypes; track type) {
                      <li>
                        <img
                          src="assets/img/icons/learning-resource-types/{{ type.learningresourcetypekey }}.svg"
                          class="img-icon"
                          [alt]=""
                          aria-hidden="true" />
                        {{ type.value }}
                      </li>
                    }
                    <li>
                      <i class="fa fa-fw fa-eye" aria-hidden="true"></i>
                      {{ educationalMaterial.viewCounter }} {{ "demo.educationalMaterial.viewCount" | translate }}
                    </li>
                    <li>
                      <i class="fa fa-fw fa-download" aria-hidden="true"></i>
                      {{ educationalMaterial.downloadCounter }} {{ "demo.educationalMaterial.downloadCount" | translate
                      }}
                    </li>
                  </ul>
                </div>
                @if (educationalMaterial.urn) {
                  <div class="col col-lg-12">
                    <p>
                      <strong class="d-block">
                        {{ "demo.educationalMaterial.pid.label.version" | translate }}
                        <app-tooltip-button key="demo.educationalMaterial.pid.tooltip" variant="help"></app-tooltip-button>
                      </strong>
                      <a href="https://urn.fi/{{ educationalMaterial.urn }}" rel="noopener noreferrer">
                        {{ educationalMaterial.urn }}
                      </a>
                    </p>
                  </div>
                }
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-9">
            <div class="material-content">
              <div class="material-description">
                <ul class="list-unstyled authors">
                  @for (author of educationalMaterial.authors; track author) {
                    <li>
                      @if (author.authorname !== '') {
                        {{ author.authorname }}
                        @if (author.organization) {
                          ({{ author.organization }})
                        }
                      }
                      @if (author.authorname === '') {
                        {{ author.organization }}
                      }
                    </li>
                  }
                </ul>
                  @if (educationalMaterial?.ownerName) {
                      <div class="d-none">
                          <strong>{{ "demo.educationalMaterial.owner" | translate }}:</strong>
                          <span data-testid="material-owner">
                              {{ educationalMaterial.ownerName.firstname }}
                              {{ educationalMaterial.ownerName.lastname }}
                          </span>
                      </div>
                  }
                <div class="datetimes">
                  @if (educationalMaterial.publishedAt) {
                    <span class="datetime-item d-block d-md-inline-block">
                      <strong>{{ "demo.educationalMaterial.publishedAt" | translate }}:</strong>
                      <time [attr.datetime]="educationalMaterial.publishedAt | date: 'yyyy-MM-dd HH:mm'">
                        {{ educationalMaterial.publishedAt | date: "d.M.yyyy HH:mm" }}
                      </time>
                    </span>
                  }
                  @if (educationalMaterial.updatedAt) {
                    <span class="datetime-item d-block d-md-inline-block">
                      <strong>{{ "demo.educationalMaterial.updatedAt" | translate }}:</strong>
                      <time [attr.datetime]="educationalMaterial.updatedAt | date: 'yyyy-MM-dd HH:mm'">
                        {{ educationalMaterial.updatedAt | date: "d.M.yyyy HH:mm" }}
                      </time>
                    </span>
                  }
                  @if (educationalMaterial.expires) {
                    <span class="datetime-item d-block d-md-inline-block">
                      <strong>{{ "demo.educationalMaterial.expires" | translate }}:</strong>
                      <time [attr.datetime]="educationalMaterial.expires | date: 'yyyy-MM-dd'">
                        {{ educationalMaterial.expires | date: "d.M.yyyy" }}
                      </time>
                    </span>
                  }
                  @if (educationalMaterial.versions?.length > 1) {
                    <div class="btn-group version-history" dropdown>
                      <button
                        id="toggle-version-history"
                        dropdownToggle
                        type="button"
                        class="btn btn-link"
                        aria-controls="version-history">
                        {{ "demo.educationalMaterial.versionHistory.button" | translate }}
                      </button>
                      <app-tooltip-button key="demo.educationalMaterial.versionHistory.helpText" variant="help"></app-tooltip-button>
                      <ul
                        id="version-history"
                        *dropdownMenu
                        class="dropdown-menu"
                        role="menu"
                        aria-labelledby="toggle-version-history">
                        @for (version of educationalMaterial.versions; track version; let isFirst = $first) {
                          <li role="menuitem">
                            <a
                              class="dropdown-item dropdown-item-version-history"
                              [routerLink]="['/materiaali', materialId, version]"
                              routerLinkActive="active"
                              [ngClass]="{ active: !materialVersionDate && isFirst }">
                              {{ version | date: "dd.MM.yyyy HH:mm:ss" }}
                            </a>
                          </li>
                        }
                      </ul>
                    </div>
                  }
                </div>
                @if (description) {
                  <p>{{ description }}</p>
                }
              </div>
              @if (materials.length > 0) {
                <div class="list-files mb-4">
                  <div class="row g-0">
                    <div class="col-md-3">
                      @if (materialLanguages.length > 1) {
                        @if (materialLanguages.length <= 3) {
                          <h2 id="selectLanguageTitle">{{ "materialPreview.selectLanguage" | translate }}</h2>
                          <div class="btn-group mb-3" role="tablist" aria-labelledby="selectLanguageTitle">
                            @for (materialLang of materialLanguages; track materialLang) {
                              <button
                                type="button"
                                class="btn btn-gray lang-selector-button"
                                [ngClass]="materialLang === selectedLanguage ? 'active' : ''"
                                [attr.aria-selected]="materialLang === selectedLanguage"
                                [attr.aria-controls]="'fileList-' + materialLang"
                                [id]="'langSelector-' + materialLang"
                                role="tab"
                                (click)="setSelectedLanguage(materialLang)">
                                {{ materialLang }}
                                <span class="visually-hidden">({{ getLanguageValue(materialLang) }})</span>
                              </button>
                            }
                          </div>
                        } @else {
                          <div class="dropdown mb-3" dropdown>
                            <button
                              class="btn btn-gray dropdown-toggle"
                              dropdownToggle
                              type="button"
                              id="selectLanguage">
                              {{ "materialPreview.selectLanguage" | translate }}
                            </button>
                            <div *dropdownMenu class="dropdown-menu" aria-labelledby="selectLanguage">
                              @for (materialLang of materialLanguages; track materialLang) {
                                <button
                                  type="button"
                                  class="dropdown-item btn-gray"
                                  [ngClass]="materialLang === selectedLanguage ? 'active' : ''"
                                  [attr.aria-selected]="materialLang === selectedLanguage"
                                  [attr.aria-controls]="'fileList-' + materialLang"
                                  [id]="'langSelector-' + materialLang"
                                  role="tab"
                                  (click)="setSelectedLanguage(materialLang)">
                                  {{ getLanguageValue(materialLang) }}
                                </button>
                              }
                            </div>
                          </div>
                        }
                      }
                      @if (materials | materialLanguage: selectedLanguage; as filteredMaterials) {
                        <div
                          [id]="'fileList-' + selectedLanguage"
                          [attr.role]="materialLanguages.length > 1 ? 'tabpanel' : null"
                          [attr.aria-labelledby]="materialLanguages.length > 1 ? ('langSelector-' + selectedLanguage) : null">
                          <h2 id="selectMaterial" [ngClass]="filteredMaterials.length === 1 ? 'visually-hidden' : ''">
                            {{ "materialPreview.selectMaterial" | translate }}
                          </h2>
                          <div class="btn-group-vertical" role="tablist" aria-labelledby="selectMaterial">
                            @for (material of filteredMaterials; track material) {
                              <button
                                type="button"
                                class="btn btn-file text-dark"
                                [ngClass]="material === previewMaterial ? 'active' : ''"
                                [attr.aria-selected]="material === previewMaterial"
                                [attr.aria-controls]="'filePreview-' + material.id"
                                [id]="'fileSelector-' + material.id"
                                role="tab"
                                (click)="setPreviewMaterial(material)">
                                {{ material.displayName[lang] }}
                              </button>
                            }
                          </div>
                        </div>
                      }
                    </div>
                    <div class="col-md-9">
                      <div
                        [id]="'filePreview-' + previewMaterial.id"
                        role="tabpanel"
                        [attr.aria-labelledby]="'fileSelector-' + previewMaterial.id">
                        @if (!previewMaterial.link) {
                          <app-educational-material-preview
                            [material]="previewMaterial"
                          ></app-educational-material-preview>
                        } @else {
                          <div class="link-preview">
                            <a
                              [href]="previewMaterial.link"
                              [attr.data-testid]="'preview-link-'+materialId"
                              class="btn btn-secondary"
                              target="_blank"
                              rel="noopener nofollow">
                              {{ "demo.educationalMaterial.preview.openInNewTab" | translate }} ({{ previewMaterialDomain
                              }})
                            </a>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              }
              <h2 class="visually-hidden">{{ "demo.educationalMaterial.detailsHeading" | translate }}</h2>
              <div class="embed-code">
                <h3>{{ "demo.educationalMaterial.embed.label" | translate }}</h3>
                <div class="input-group mb-4">
                  <input
                    type="text"
                    class="form-control"
                    id="embedCodeInput"
                    [attr.aria-label]="'demo.educationalMaterial.embed.label' | translate"
                    [value]="embedCode"
                    readonly
                    #embedCodeInput
                    (focus)="$event.target.select()" />
                  <button
                    class="btn"
                    type="button"
                    (click)="copyEmbedCode()"
                    [ngClass]="{
                      'btn-outline-secondary': !embedCodeCopied,
                      'btn-success': embedCodeCopied
                    }">
                    @if (!embedCodeCopied) {
                      {{ "demo.educationalMaterial.embed.copy" | translate }}
                    } @else {
                      {{ "demo.educationalMaterial.embed.copied" | translate }}
                    }
                  </button>
                </div>
              </div>
              <div class="metadata">
                <div class="row">
                  @if (educationalMaterial.timeRequired) {
                    <div class="col-auto">
                      <h3>{{ "demo.educationalMaterial.timeRequired" | translate }}</h3>
                      {{ educationalMaterial.timeRequired }}
                    </div>
                  }
                  @if (educationalMaterial.publisher?.length > 0) {
                    <div class="col-auto">
                      <h3>{{ "demo.educationalMaterial.publisher" | translate }}</h3>
                      @for (publisher of educationalMaterial.publisher; track publisher; let isLast = $last) {
                        {{ publisher }}
                        @if (!isLast) {
                          <span>,</span>
                        }
                      }
                    </div>
                  }
                  <div class="col-auto">
                    <h3>{{ "demo.educationalMaterial.license" | translate }}</h3>
                    <a
                      [href]="getLicense(educationalMaterial.license?.key)?.link"
                      target="_blank"
                      rel="noopener noreferrer">
                      {{ getLicense(educationalMaterial.license?.key)?.value }}
                    </a>
                  </div>
                  <div class="col-12">
                    @if (educationalMaterial.keywords?.length > 0) {
                      <app-taglist
                        elementId="material-keywords"
                        [tags]="educationalMaterial.keywords"
                        [title]="'demo.educationalMaterial.keywords' | translate"
                        property="value"
                        searchProperty="keywordkey"
                      filterType="keywords"></app-taglist>
                    }
                    <!--keywords-->
                  </div>
                </div>
                <button
                  type="button"
                  class="btn btn-link"
                  (click)="detailsExpanded = !detailsExpanded"
                  [attr.aria-expanded]="detailsExpanded"
                  aria-controls="material-details">
                  @if (detailsExpanded) {
                    {{ "demo.educationalMaterial.expandMetadata.less" | translate }}
                  } @else {
                    {{ "demo.educationalMaterial.expandMetadata.more" | translate }}
                  }
                </button>
                <div id="material-details" [collapse]="!detailsExpanded" [isAnimated]="true">
                    @if (educationalMaterial.educationalLevels?.length > 0) {
                      <div class="metadata-group">
                        <app-taglist
                          elementId="material-educationalLevels"
                          [tags]="educationalMaterial.educationalLevels"
                          [title]="'demo.educationalMaterial.eduLevel' | translate"
                          property="value"
                          searchProperty="educationallevelkey"
                        filterType="educationalLevels"></app-taglist>
                        <!--educationalLevels-->
                      </div>
                    }
                    @if (educationalMaterial.educationalRoles?.length > 0) {
                      <div class="metadata-group">
                        <app-taglist
                          elementId="material-educationalRoles"
                          [tags]="educationalMaterial.educationalRoles"
                          [title]="'demo.educationalMaterial.educationalRole' | translate"
                          property="educationalrole"
                          searchProperty="educationalrolekey"
                        filterType="educationalRoles"></app-taglist>
                        <!--educationalRoles-->
                      </div>
                    }
                    @if (educationalMaterial.educationalUses?.length > 0) {
                      <div class="metadata-group">
                        <app-taglist
                          elementId="material-educationalUses"
                          [tags]="educationalMaterial.educationalUses"
                          [title]="'demo.educationalMaterial.educationalUse' | translate"
                          property="value"
                          searchProperty="educationalusekey"
                        filterType="educationalUses"></app-taglist>
                        <!--educationalUses-->
                      </div>
                    }
                    <!-- early childhood education -->
                    @if (
                      educationalMaterial.earlyChildhoodEducationSubjects?.length > 0 ||
                      educationalMaterial.suitsAllEarlyChildhoodSubjects
                      ) {
                      <div
                        class="metadata-group">
                        <app-taglist
                          elementId="material-earlyChildhoodEducationSubjects"
                          [tags]="educationalMaterial.earlyChildhoodEducationSubjects"
                          [title]="'demo.educationalMaterial.earlyChildhoodEducationSubjects' | translate"
                          property="targetName"
                          searchProperty="key"
                          filterType="educationalSubjects"
                        [suitsAll]="educationalMaterial.suitsAllEarlyChildhoodSubjects"></app-taglist>
                        <!--earlyChildhoodEducationSubjects-->
                      </div>
                    }
                    @if (educationalMaterial.earlyChildhoodEducationFrameworks?.length > 0) {
                      <div
                        class="metadata-group">
                        <app-taglist
                          elementId="material-earlyChildhoodEducationFrameworks"
                          [tags]="educationalMaterial.earlyChildhoodEducationFrameworks"
                        [title]="'demo.educationalMaterial.earlyChildhoodEducationFrameworks' | translate"></app-taglist>
                        <!--earlyChildhoodEducationFrameworks-->
                      </div>
                    }
                    @if (educationalMaterial.earlyChildhoodEducationObjectives?.length > 0) {
                      <div
                        class="metadata-group">
                        <app-taglist
                          elementId="material-earlyChildhoodEducationObjectives"
                          [tags]="educationalMaterial.earlyChildhoodEducationObjectives"
                          [title]="'demo.educationalMaterial.earlyChildhoodEducationObjectives' | translate"
                          property="targetName"
                          searchProperty="key"
                        filterType="teaches"></app-taglist>
                        <!--earlyChildhoodEducationObjectives-->
                      </div>
                    }
                    <!-- pre primary education -->
                    @if (
                      educationalMaterial.prePrimaryEducationSubjects?.length > 0 ||
                      educationalMaterial.suitsAllPrePrimarySubjects
                      ) {
                      <div
                        class="metadata-group">
                        <app-taglist
                          elementId="material-prePrimaryEducationSubjects"
                          [tags]="educationalMaterial.prePrimaryEducationSubjects"
                          [title]="'demo.educationalMaterial.prePrimaryEducationSubjects' | translate"
                          property="targetName"
                          searchProperty="key"
                          filterType="educationalSubjects"
                        [suitsAll]="educationalMaterial.suitsAllPrePrimarySubjects"></app-taglist>
                        <!--prePrimaryEducationSubjects-->
                      </div>
                    }
                    @if (educationalMaterial.prePrimaryEducationFrameworks?.length > 0) {
                      <div class="metadata-group">
                        <app-taglist
                          elementId="material-prePrimaryEducationFrameworks"
                          [tags]="educationalMaterial.prePrimaryEducationFrameworks"
                        [title]="'demo.educationalMaterial.prePrimaryEducationFrameworks' | translate"></app-taglist>
                        <!--prePrimaryEducationFrameworks-->
                      </div>
                    }
                    @if (educationalMaterial.prePrimaryEducationObjectives?.length > 0) {
                      <div class="metadata-group">
                        <app-taglist
                          elementId="material-prePrimaryEducationObjectives"
                          [tags]="educationalMaterial.prePrimaryEducationObjectives"
                          [title]="'demo.educationalMaterial.prePrimaryEducationObjectives' | translate"
                          property="targetName"
                          searchProperty="key"
                        filterType="teaches"></app-taglist>
                        <!--prePrimaryEducationObjectives-->
                      </div>
                    }
                    <!-- basic education -->
                    @if (
                      educationalMaterial.basicStudySubjects?.length > 0 ||
                      educationalMaterial.suitsAllBasicStudySubjects
                      ) {
                      <div
                        class="metadata-group">
                        <app-taglist
                          elementId="material-basicStudySubjects"
                          [tags]="educationalMaterial.basicStudySubjects"
                          [title]="'demo.educationalMaterial.basicStudySubjects' | translate"
                          property="targetName"
                          searchProperty="key"
                          filterType="educationalSubjects"
                        [suitsAll]="educationalMaterial.suitsAllBasicStudySubjects"></app-taglist>
                        <!--basicStudySubjects-->
                      </div>
                    }
                    @if (educationalMaterial.basicStudyFrameworks?.length > 0) {
                      <div class="metadata-group">
                        <app-taglist
                          elementId="material-basicStudyFrameworks"
                          [tags]="educationalMaterial.basicStudyFrameworks"
                        [title]="'demo.educationalMaterial.basicStudyFrameworks' | translate"></app-taglist>
                        <!--basicStudyFrameworks-->
                      </div>
                    }
                    @if (educationalMaterial.basicStudyObjectives?.length > 0) {
                      <div class="metadata-group">
                        <app-taglist
                          elementId="material-basicStudyObjectives"
                          [tags]="educationalMaterial.basicStudyObjectives"
                          [title]="'demo.educationalMaterial.basicStudyObjectives' | translate"
                          property="targetName"
                          searchProperty="key"
                        filterType="teaches"></app-taglist>
                        <!--basicStudyObjectives-->
                      </div>
                    }
                    @if (educationalMaterial.basicStudyContents?.length > 0) {
                      <div class="metadata-group">
                        <app-taglist
                          elementId="material-basicStudyContents"
                          [tags]="educationalMaterial.basicStudyContents"
                          [title]="'demo.educationalMaterial.basicStudyContents' | translate"
                          property="targetName"
                          searchProperty="key"
                        filterType="teaches"></app-taglist>
                        <!--basicStudyContents-->
                      </div>
                    }
                    <!-- preparatory education -->
                    @if (educationalMaterial.preparatoryEducationSubjects.length > 0) {
                      <div class="metadata-group">
                        <app-taglist
                          elementId="material-preparatoryEducationSubjects"
                          [tags]="educationalMaterial.preparatoryEducationSubjects"
                          [title]="'demo.educationalMaterial.preparatoryEducationSubjects' | translate"
                          property="targetName"
                          searchProperty="key"
                        filterType="preparatoryEducationSubjects"></app-taglist>
                        <!--preparatoryEducationSubjects-->
                      </div>
                    }
                    @if (educationalMaterial.preparatoryEducationObjectives?.length > 0) {
                      <div class="metadata-group">
                        <app-taglist
                          elementId="material-preparatoryEducationObjectives"
                          [tags]="educationalMaterial.preparatoryEducationObjectives"
                          [title]="'demo.educationalMaterial.preparatoryEducationObjectives' | translate"
                          property="targetName"
                          searchProperty="key"
                        filterType="teaches"></app-taglist>
                        <!--preparatoryEducationObjectives-->
                      </div>
                    }
                    <!--/preparatory education-->
                    <!-- upper secondary education -->
                    @if (
                      educationalMaterial.upperSecondarySchoolSubjectsOld?.length > 0 ||
                      educationalMaterial.suitsAllUpperSecondarySubjects
                      ) {
                      <div
                        class="metadata-group">
                        <app-taglist
                          elementId="material-upperSecondarySchoolSubjectsOld"
                          [tags]="educationalMaterial.upperSecondarySchoolSubjectsOld"
                          [title]="'demo.educationalMaterial.upperSecondarySchoolSubjects' | translate"
                          property="targetName"
                          searchProperty="key"
                          filterType="educationalSubjects"
                        [suitsAll]="educationalMaterial.suitsAllUpperSecondarySubjects"></app-taglist>
                        <!--upperSecondarySchoolSubjectsOld-->
                      </div>
                    }
                    @if (educationalMaterial.upperSecondarySchoolFrameworks?.length > 0) {
                      <div class="metadata-group">
                        <app-taglist
                          elementId="material-upperSecondarySchoolFrameworks"
                          [tags]="educationalMaterial.upperSecondarySchoolFrameworks"
                        [title]="'demo.educationalMaterial.upperSecondarySchoolFrameworks' | translate"></app-taglist>
                        <!--upperSecondarySchoolFrameworks-->
                      </div>
                    }
                    @if (educationalMaterial.upperSecondarySchoolCoursesOld?.length > 0) {
                      <div class="metadata-group">
                        <app-taglist
                          elementId="material-upperSecondarySchoolCoursesOld"
                          [tags]="educationalMaterial.upperSecondarySchoolCoursesOld"
                          [title]="'demo.educationalMaterial.upperSecondarySchoolCourses' | translate"
                          property="targetName"
                          searchProperty="key"
                        filterType="educationalSubjects"></app-taglist>
                        <!--upperSecondarySchoolCoursesOld-->
                      </div>
                    }
                    @if (educationalMaterial.upperSecondarySchoolObjectives?.length > 0) {
                      <div class="metadata-group">
                        <app-taglist
                          elementId="material-upperSecondarySchoolObjectives"
                          [tags]="educationalMaterial.upperSecondarySchoolObjectives"
                          [title]="'demo.educationalMaterial.upperSecondarySchoolObjectives' | translate"
                          property="targetName"
                          searchProperty="key"
                        filterType="teaches"></app-taglist>
                        <!--upperSecondarySchoolObjectives-->
                      </div>
                    }
                    <!-- upper secondary education (new) -->
                    @if (
                      educationalMaterial.upperSecondarySchoolSubjectsNew?.length > 0 ||
                      educationalMaterial.suitsAllUpperSecondarySubjectsNew
                      ) {
                      <div
                        class="metadata-group">
                        <app-taglist
                          elementId="material-upperSecondarySchoolSubjectsNew"
                          [tags]="educationalMaterial.upperSecondarySchoolSubjectsNew"
                          [title]="'demo.educationalMaterial.upperSecondarySchoolSubjectsNew' | translate"
                          property="targetName"
                          searchProperty="key"
                          filterType="educationalSubjects"
                        [suitsAll]="educationalMaterial.suitsAllUpperSecondarySubjectsNew"></app-taglist>
                        <!--upperSecondarySchoolSubjectsNew-->
                      </div>
                    }
                    <!-- <div
                    *ngIf="educationalMaterial.upperSecondarySchoolFrameworksNew?.length > 0"
                    class="metadata-group">
                    <app-taglist
                      elementId="material-upperSecondarySchoolFrameworksNew"
                      [tags]="educationalMaterial.upperSecondarySchoolFrameworksNew"
                    [title]="'demo.educationalMaterial.upperSecondarySchoolFrameworksNew' | translate"></app-taglist>
                  </div> -->
                  @if (educationalMaterial.upperSecondarySchoolModulesNew?.length > 0) {
                    <div class="metadata-group">
                      <app-taglist
                        elementId="material-upperSecondarySchoolModulesNew"
                        [tags]="educationalMaterial.upperSecondarySchoolModulesNew"
                        [title]="'demo.educationalMaterial.upperSecondarySchoolModulesNew' | translate"
                        property="targetName"
                        searchProperty="key"
                      filterType="educationalSubjects"></app-taglist>
                      <!--upperSecondarySchoolModulesNew-->
                    </div>
                  }
                  @if (educationalMaterial.upperSecondarySchoolObjectivesNew?.length > 0) {
                    <div
                      class="metadata-group">
                      <app-taglist
                        elementId="material-upperSecondarySchoolObjectivesNew"
                        [tags]="educationalMaterial.upperSecondarySchoolObjectivesNew"
                        [title]="'demo.educationalMaterial.upperSecondarySchoolObjectivesNew' | translate"
                        property="targetName"
                        searchProperty="key"
                      filterType="teaches"></app-taglist>
                      <!--upperSecondarySchoolObjectivesNew-->
                    </div>
                  }
                  @if (educationalMaterial.upperSecondarySchoolContentsNew?.length > 0) {
                    <div class="metadata-group">
                      <app-taglist
                        elementId="material-upperSecondarySchoolContentsNew"
                        [tags]="educationalMaterial.upperSecondarySchoolContentsNew"
                        [title]="'demo.educationalMaterial.upperSecondarySchoolContentsNew' | translate"
                        property="targetName"
                        searchProperty="key"
                      filterType="teaches"></app-taglist>
                      <!--upperSecondarySchoolContentsNew-->
                    </div>
                  }
                  @if (educationalMaterial.newUpperSecondarySchoolFrameworks?.length > 0) {
                    <div
                      class="metadata-group">
                      <app-taglist
                        elementId="material-newUpperSecondarySchoolFrameworks"
                        [tags]="educationalMaterial.newUpperSecondarySchoolFrameworks"
                      [title]="'demo.educationalMaterial.newUpperSecondarySchoolFrameworks' | translate"></app-taglist>
                      <!--newUpperSecondarySchoolFrameworks-->
                    </div>
                  }
                  <!-- vocational education -->
                  @if (
                    educationalMaterial.vocationalDegrees?.length > 0 ||
                    educationalMaterial.suitsAllVocationalDegrees
                    ) {
                    <div
                      class="metadata-group">
                      <app-taglist
                        elementId="material-vocationalDegrees"
                        [tags]="educationalMaterial.vocationalDegrees"
                        [title]="'demo.educationalMaterial.vocationalDegrees' | translate"
                        property="targetName"
                        searchProperty="key"
                        filterType="educationalSubjects"
                      [suitsAll]="educationalMaterial.suitsAllVocationalDegrees"></app-taglist>
                      <!--vocationalDegrees-->
                    </div>
                  }
                  @if (educationalMaterial.vocationalFrameworks?.length > 0) {
                    <div class="metadata-group">
                      <app-taglist
                        elementId="material-vocationalFrameworks"
                        [tags]="educationalMaterial.vocationalFrameworks"
                      [title]="'demo.educationalMaterial.vocationalFrameworks' | translate"></app-taglist>
                      <!--vocationalFrameworks-->
                    </div>
                  }
                  <!-- @todo: whats up with this? 6.8.2021-->
                  <!--<div *ngIf="educationalMaterial.furtherVocationalQualifications?.length > 0 || educationalMaterial.suitsAllVocationalDegrees" class="metadata-group">
                  <app-taglist
                    elementId="material-furtherVocationalQualifications"
                    [tags]="educationalMaterial.furtherVocationalQualifications"
                    [title]="'demo.educationalMaterial.furtherVocationalQualifications' | translate"
                    property="targetName"
                    searchProperty="key"
                    filterType="furtherVocationalQualifications"
                    [suitsAll]="educationalMaterial.suitsAllVocationalDegrees"
                  ></app-taglist>&lt;!&ndash;furtherVocationalQualifications&ndash;&gt;
                </div>
                <div *ngIf="educationalMaterial.specialistVocationalQualifications?.length > 0 || educationalMaterial.suitsAllVocationalDegrees" class="metadata-group">
                  <app-taglist
                    elementId="material-specialistVocationalQualifications"
                    [tags]="educationalMaterial.specialistVocationalQualifications"
                    [title]="'demo.educationalMaterial.specialistVocationalQualifications' | translate"
                    property="targetName"
                    searchProperty="key"
                    filterType="specialistVocationalQualifications"
                    [suitsAll]="educationalMaterial.suitsAllVocationalDegrees"
                  ></app-taglist>&lt;!&ndash;specialistVocationalQualifications&ndash;&gt;
                </div>-->
                @if (educationalMaterial.vocationalCommonUnits?.length > 0) {
                  <div class="metadata-group">
                    <app-taglist
                      elementId="material-vocationalCommonUnits"
                      [tags]="educationalMaterial.vocationalCommonUnits"
                      [title]="'demo.educationalMaterial.vocationalCommonUnits' | translate"
                      property="targetName"
                      searchProperty="key"
                    filterType="educationalSubjects"></app-taglist>
                    <!--vocationalCommonUnits-->
                  </div>
                }
                @if (educationalMaterial.vocationalUnits?.length > 0) {
                  <div class="metadata-group">
                    <app-taglist
                      elementId="material-vocationalUnits"
                      [tags]="educationalMaterial.vocationalUnits"
                      [title]="'demo.educationalMaterial.vocationalUnits' | translate"
                      property="targetName"
                      searchProperty="key"
                    filterType="educationalSubjects"></app-taglist>
                    <!--vocationalUnits-->
                  </div>
                }
                @if (educationalMaterial.vocationalRequirements?.length > 0) {
                  <div class="metadata-group">
                    <app-taglist
                      elementId="material-vocationalRequirements"
                      [tags]="educationalMaterial.vocationalRequirements"
                      [title]="'demo.educationalMaterial.vocationalEducationObjectives' | translate"
                      property="targetName"
                      searchProperty="key"
                    filterType="teaches"></app-taglist>
                    <!--vocationalRequirements-->
                  </div>
                }
                <!-- self-motivated education -->
                @if (
                  educationalMaterial.selfMotivatedEducationSubjects?.length > 0 ||
                  educationalMaterial.suitsAllSelfMotivatedSubjects
                  ) {
                  <div
                    class="metadata-group">
                    <app-taglist
                      elementId="material-selfMotivatedEducationSubjects"
                      [tags]="educationalMaterial.selfMotivatedEducationSubjects"
                      [title]="'demo.educationalMaterial.selfMotivatedEducationSubjects' | translate"
                      property="targetName"
                      searchProperty="key"
                      filterType="educationalSubjects"
                    [suitsAll]="educationalMaterial.suitsAllSelfMotivatedSubjects"></app-taglist>
                    <!--selfMotivatedEducationSubjects-->
                  </div>
                }
                @if (educationalMaterial.selfMotivatedEducationObjectives?.length > 0) {
                  <div
                    class="metadata-group">
                    <app-taglist
                      elementId="material-selfMotivatedEducationObjectives"
                      [tags]="educationalMaterial.selfMotivatedEducationObjectives"
                      [title]="'demo.educationalMaterial.selfMotivatedEducationObjectives' | translate"
                      property="targetName"
                      searchProperty="key"
                    filterType="teaches"></app-taglist>
                    <!--selfMotivatedEducationObjectives-->
                  </div>
                }
                <!-- higher education -->
                @if (educationalMaterial.branchesOfScience?.length > 0 || educationalMaterial.suitsAllBranches) {
                  <div
                    class="metadata-group">
                    <app-taglist
                      elementId="material-scienceBranches"
                      [tags]="educationalMaterial.branchesOfScience"
                      [title]="'demo.educationalMaterial.branchesOfScience' | translate"
                      property="targetName"
                      searchProperty="key"
                      filterType="educationalSubjects"
                    [suitsAll]="educationalMaterial.suitsAllBranches"></app-taglist>
                    <!--scienceBranches-->
                  </div>
                }
                @if (educationalMaterial.higherEducationFrameworks?.length > 0) {
                  <div class="metadata-group">
                    <app-taglist
                      elementId="material-higherEducationFrameworks"
                      [tags]="educationalMaterial.higherEducationFrameworks"
                    [title]="'demo.educationalMaterial.higherEducationFrameworks' | translate"></app-taglist>
                    <!--higherEducationFrameworks-->
                  </div>
                }
                @if (educationalMaterial.scienceBranchObjectives?.length > 0) {
                  <div class="metadata-group">
                    <app-taglist
                      elementId="material-scienceBranchObjectives"
                      [tags]="educationalMaterial.scienceBranchObjectives"
                      [title]="'demo.educationalMaterial.scienceBranchObjectives' | translate"
                      property="targetName"
                      searchProperty="key"
                    filterType="teaches"></app-taglist>
                    <!--scienceBranchObjectives-->
                  </div>
                }
                <!-- prerequisites -->
                @if (educationalMaterial.prerequisites?.length > 0) {
                  <div class="metadata-group">
                    <app-taglist
                      elementId="material-prerequisites"
                      [tags]="educationalMaterial.prerequisites"
                      [title]="'demo.educationalMaterial.prerequisites' | translate"
                    property="targetName"></app-taglist>
                    <!--prerequisites-->
                  </div>
                }
                <!-- accessibility -->
                @if (educationalMaterial.accessibilityFeatures?.length > 0) {
                  <div class="metadata-group">
                    <app-taglist
                      elementId="material-accessibilityFeatures"
                      [tags]="educationalMaterial.accessibilityFeatures"
                      [title]="'demo.educationalMaterial.accessibilityFeatures' | translate"
                      property="value"
                      searchProperty="accessibilityfeaturekey"
                    filterType="accessibilityFeatures"></app-taglist>
                    <!--accessibilityFeatures-->
                  </div>
                }
                @if (educationalMaterial.accessibilityHazards?.length > 0) {
                  <div class="metadata-group">
                    <app-taglist
                      elementId="material-accessibilityHazards"
                      [tags]="educationalMaterial.accessibilityHazards"
                      [title]="'demo.educationalMaterial.accessibilityHazard' | translate"
                      property="value"
                      searchProperty="accessibilityhazardkey"
                    filterType="accessibilityHazards"></app-taglist>
                    <!--accessibilityHazards-->
                  </div>
                }
                <!-- typicalAgeRange -->
                @if (
                  educationalMaterial.typicalAgeRange.typicalAgeRangeMin ||
                  educationalMaterial.typicalAgeRange.typicalAgeRangeMax
                  ) {
                  <div
                    class="metadata-group">
                    <strong class="h3 d-block mb-2">
                      {{ "demo.educationalMaterial.typicalAgeRange" | translate }}
                    </strong>
                    @if (
                      educationalMaterial.typicalAgeRange.typicalAgeRangeMin &&
                      educationalMaterial.typicalAgeRange.typicalAgeRangeMax) {
                      {{ educationalMaterial.typicalAgeRange.typicalAgeRangeMin }} &ndash; {{
                      educationalMaterial.typicalAgeRange.typicalAgeRangeMax }}
                    } @else {
                      @if (educationalMaterial.typicalAgeRange.typicalAgeRangeMin) {
                        &gt; {{ educationalMaterial.typicalAgeRange.typicalAgeRangeMin }}
                      }
                      @if (educationalMaterial.typicalAgeRange.typicalAgeRangeMax) {
                        &lt; {{ educationalMaterial.typicalAgeRange.typicalAgeRangeMax }}
                      }
                    }
                  </div>
                }
            </div>
          </div>
        </div>
        <div class="ratings">
          <h2>{{ "demo.educationalMaterial.userReviews.title" | translate }}</h2>
          <h3>{{ "demo.educationalMaterial.socialMetadata.title" | translate }}</h3>
          @if (
            socialMetadata?.keywords?.length > 0 ||
            socialMetadata?.accessibilityFeatures?.length > 0 ||
            socialMetadata?.accessibilityHazards?.length > 0 ||
            socialMetadata?.educationalLevels?.length > 0) {
            <div
              class="row"
              >
              <!--keywords-->
              @if (socialMetadata?.keywords?.length > 0) {
                <div class="col-auto metadata-group">
                  @if (socialMetadata?.keywords?.length > 0) {
                    <app-taglist
                      elementId="socialMetadata-keywords"
                      [tags]="socialMetadata?.keywords"
                      [title]="'demo.educationalMaterial.keywords' | translate"
                      property="value"
                      searchProperty="key"
                    filterType="keywords"></app-taglist>
                  }
                </div>
              }
              <!--keywords-->
              <!--accessibilityFeatures-->
              @if (socialMetadata?.accessibilityFeatures?.length > 0) {
                <div class="col-auto metadata-group">
                  <app-taglist
                    elementId="socialMetadata-accessibilityFeatures"
                    [tags]="socialMetadata?.accessibilityFeatures"
                    [title]="'demo.educationalMaterial.accessibilityFeatures' | translate"
                    property="value"
                    searchProperty="key"
                  filterType="accessibilityFeatures"></app-taglist>
                </div>
              }
              <!--accessibilityFeatures-->
              <!--accessibilityHazards-->
              @if (socialMetadata?.accessibilityHazards?.length > 0) {
                <div class="col-auto metadata-group">
                  <app-taglist
                    elementId="socialMetadata-accessibilityHazards"
                    [tags]="socialMetadata?.accessibilityHazards"
                    [title]="'demo.educationalMaterial.accessibilityHazard' | translate"
                    property="value"
                    searchProperty="key"
                  filterType="accessibilityHazards"></app-taglist>
                </div>
              }
              <!--accessibilityHazards-->
              <!--educationalLevels-->
              @if (socialMetadata?.educationalLevels?.length > 0) {
                <div class="col-auto metadata-group">
                  <app-taglist
                    elementId="socialMetadata-educationalLevels"
                    [tags]="socialMetadata?.educationalLevels"
                    [title]="'demo.educationalMaterial.eduLevel' | translate"
                    property="value"
                    searchProperty="key"
                  filterType="educationalLevels"></app-taglist>
                </div>
              }
              <!--educationalLevels-->
            </div>
          } @else {
            <p>{{ "demo.educationalMaterial.socialMetadata.noMetadata" | translate }}</p>
          }
          <!--social metadata-->
          @if (authService.hasUserData() && !educationalMaterial.owner) {
            <button type="button" class="btn btn-anchor mb-4" (click)="openSocialMetadataModal($event)">
              {{ "demo.educationalMaterial.socialMetadata.addMetadata" | translate }}
            </button>
          }
          <h3>{{ "demo.educationalMaterial.userReviews.title" | translate }}</h3>
          <div class="row mb-2">
            @if (educationalMaterial.ratingContentAverage || educationalMaterial.ratingVisualAverage) {
              @if (educationalMaterial.ratingContentAverage) {
                <div class="col-auto">
                  <strong>{{ "demo.educationalMaterial.userReviews.ratingContent" | translate }}:</strong>
                  {{ educationalMaterial.ratingContentAverage }}
                  <span class="text-muted">/ 5</span>
                </div>
              }
              @if (educationalMaterial.ratingVisualAverage) {
                <div class="col-auto">
                  <strong>{{ "demo.educationalMaterial.userReviews.ratingVisual" | translate }}:</strong>
                  {{ educationalMaterial.ratingVisualAverage }}
                  <span class="text-muted">/ 5</span>
                </div>
              }
            }
            <div class="col-auto">
              <a routerLink="arvostelut">{{ "demo.educationalMaterial.userReviews.allReviews" | translate }}</a>
            </div>
            @if (authService.hasUserData() && !educationalMaterial.owner) {
              <div class="col-auto">
                <button type="button" class="btn btn-anchor" (click)="openReviewModal($event)">
                  {{ "demo.educationalMaterial.userReviews.addReview" | translate }}
                </button>
              </div>
            }
          </div>
          @if (authService.hasUserData() && educationalMaterial.owner) {
            <p>
              {{ "demo.educationalMaterial.reviews.ownerInfo" | translate }}
            </p>
          }
        </div>
        @if (educationalMaterial.references?.length > 0) {
          <div class="references">
            <h2>{{ "demo.educationalMaterial.references.title" | translate }}</h2>
            @for (reference of educationalMaterial.references; track reference) {
              <div class="reference">
                <div class="row">
                  <div class="col">
                    <strong>{{ reference.name }}</strong>
                    <ul class="list-unstyled mb-0">
                      @for (author of reference.authors; track author) {
                        <li>{{ author }}</li>
                      }
                    </ul>
                  </div>
                  <div class="col-auto">
                    <i class="fa fa-external-link me-2" aria-hidden="true"></i>
                    <a [href]="reference.url" target="_blank" rel="noopener" class="text-blue">
                      {{ "demo.educationalMaterial.references.openLink" | translate }}
                    </a>
                  </div>
                </div>
              </div>
            }
          </div>
        }
      </div>
    </div>
  }
}

</div>
</div>
